import { render, staticRenderFns } from "./ProposedProjectsPage.vue?vue&type=template&id=6ab7c6e4&scoped=true"
import script from "./ProposedProjectsPage.vue?vue&type=script&lang=ts"
export * from "./ProposedProjectsPage.vue?vue&type=script&lang=ts"
import style0 from "./ProposedProjectsPage.vue?vue&type=style&index=0&id=6ab7c6e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab7c6e4",
  null
  
)

export default component.exports